import { render, staticRenderFns } from "./NewNewMenu.vue?vue&type=template&id=fd67e632&scoped=true&"
import script from "./NewNewMenu.vue?vue&type=script&lang=js&"
export * from "./NewNewMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewNewMenu.vue?vue&type=style&index=0&id=fd67e632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd67e632",
  null
  
)

export default component.exports